import "../../components/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../components/Navbar";
import Select from "react-select";
import { tokens, alert, select_style, toFixed, total, GET, POST, format_date, float, validate, DatePicker, NumberZero, getStorage, fieldSorter, loading } from "../../components/CustomComponent.js";
import React, { Component } from "react";
import Resizer from "react-image-file-resizer";

const role = getStorage("role_detail");
const select_role = role?.find((item) => item.name === "record-other");
const view_r = select_role?.role[0] === 1;
const create_r = select_role?.role[1] === 1;

export default class RecordOther extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    data_customer: null, data_manage: null, customer_id: "",
    record_date: new Date(), record_time: `${NumberZero(new Date().getHours())}:${NumberZero(new Date().getMinutes())}`,
    iw_number: "", payment_type: 1, transfer_date: "", transfer_time: "", full_name: "", project_name: "", address: "",
    total_amount: 0.0, photo: "", code: "", title: "", cost: "", description: "", address_number: null, is_upload_slip: false, disable_button: false
  });

  async componentDidMount() {
    if (view_r) {
      loading(true);
      await Promise.all([this.GetRunningNumber(), this.GetCustomerAll(), this.GetDocumentManageAll()]);
      loading(false);
    }
  }

  GetDocumentManageAll = async () => {
    let result = await GET(tokens, "v1/TH/document-manage/pay-list/filter-search/page/0", { data_search: "" });
    if (result?.status) this.setState({ data_manage: result.data.data });
  };

  GetCustomerAll = async () => {
    let result = await GET(tokens, `v1/TH/customer-manage/filter-search/page/0/${getStorage("project_id")}`, { data_search: "", transfer_date: "", status_transfer: "" });
    if (result?.status) {
      this.setState({ data_customer: result.data.data.map((item) => ({ value: item.customer_id, label: `อาคาร ${item.building} ห้อง ${item.address_number}`, ...item })) });
    }
  };

  GetRunningNumber = async () => {
    let result = await GET(tokens, `v1/TH/record-receipt/running-iw/${getStorage("project_id")}`, { format_doc: "IW" });
    if (result?.status) {
      this.setState({ iw_number: result.data.data });
      // คืนเลขตรงๆ ให้ผู้เรียกใช้ทันที (ไม่พึ่ง this.state ที่ setState ยังไม่ทันอัปเดต)
      return result.data.data;
    }
    return null;
  };

  // เลขที่ใบเสร็จจริงจาก response (backend อาจออกเลขใหม่ให้ถ้าเลขที่ส่งไปชน) · ไม่มีมา = ใช้เลขที่ส่งไป
  pickIwNumber = (result, sent) => {
    const d = result?.data;
    const n = (d && typeof d === "object" ? d.iw_number : null) || result?.iw_number;
    return n ? String(n) : sent;
  };

  Create = async () => {
    // กันกดรัว: flag บน instance เช็คได้ทันที ไม่รอ setState
    if (this._submitting) return;
    this._submitting = true;
    this.setState({ disable_button: true });
    loading(true);
    try {
    // ขอเลขที่ล่าสุดก่อนบันทึกทุกครั้ง ใช้เลขที่ได้ตรงๆ ถ้าขอไม่ได้ค่อยใช้เลขเดิมใน state
    const sent_iw_number = (await this.GetRunningNumber()) || this.state.iw_number;
    
    const { customer_id, record_date, record_time, payment_type, transfer_date, transfer_time, full_name, project_name, address, code, title, description, cost, total_amount, photo } = this.state;
    const data = {
      customer_id, 
      record_water_list: [], 
      record_date: new Date(record_date).toISOString().split("T")[0], 
      record_time,
      iw_number: sent_iw_number,
      payment_type, 
      transfer_date: transfer_date || null, 
      transfer_time: transfer_time || null,
      full_name, 
      project_name, 
      agency_name: project_name,
      address,
      address_number: "",
      sum_unit_used: 0,
      payment_list: [],
      record_other_list: [{ code, title, description, cost: Number(cost) }],
      clement_remark: "",
      total_amount,
      change_satang: 0,
      total_final: total_amount,
      add_on_add_debt: 0,
      add_on_reduce_debt: 0,
      add_on_add_debt_remark: "",
      add_on_reduce_debt_remark: "",
      photo: photo || "",
    };
    console.log("data:",data)

    let result = await POST(tokens, `v1/TH/record-receipt/create/${getStorage("project_id")}`, data);
    if (result?.status) {
      const iw_number = this.pickIwNumber(result, sent_iw_number);
      await this.Print(iw_number);
      alert("success", "สำเร็จ", `บันทึกใบแจ้งหนี้หมายเลข "${iw_number}" สำเร็จแล้ว`, "/record-other");
      this.clear_form();
      this.GetRunningNumber();
    }
    } catch (e) {
      console.log(e);
    } finally {
      this._submitting = false;
      this.setState({ disable_button: false });
      loading(false);
    }
  };

  Print = async (iw_number) => {
    loading(true);
    this.setState({ delete_remark: "" });
    try{
          const array_cost = [ "add_debt", "cable_cost", "common_expenses", "equipment_maintenance_fee", "fire_cost", "late_payment", "meter_connect_cost", "other_income", "reduce_debt", "waste_cost", "water_bill" ];
          let result = await GET(tokens, "v1/TH/record-receipt/history/by-iw-number/" + getStorage("project_id"), { iw_number });
          if (result?.status) {
            let data = result.data.data;

            console.log("data:", data);
            const baseHeader = {
              project_name: getStorage("project_name"),
              project_address: `เลขที่ ${getStorage("project_address")}\nเบอร์โทรติดต่อ  ${getStorage("phone_number")} เลขที่ผู้เสียภาษี ${getStorage("tax_number")}`,
              cutomer_name: data.full_name,
              cutomer_address: data.address || data.address_number,
              number: data.iw_number,
              date: format_date(data.record_date, "dd mmmm yyyy"),
              payment: data.payment_type === 1 ? "เงินสด" : "โอนเงินเข้าบัญชีนิติฯ",
              payment_date: `${format_date(data.transfer_date || data.record_date, "dd/mm/yyyy")} เวลา ${(data.transfer_time || data.record_time)?.slice(0, 5)}`
            };
    
            if (data?.record_other_list.length !== 0) {
              // ใบเสร็จอื่นๆ
              localStorage.setItem("DATA_", JSON.stringify({
                ...baseHeader, 
                title: data.record_other_list?.[0]?.title, 
                description: data.record_other_list?.[0]?.description,
                cost: data.record_other_list?.[0]?.cost, 
                total: data.record_other_list?.[0]?.cost, 
                change_satang: 0,
              }));
              window.open("/doc/receipt-other", "_blank");
            } else {
              // ใบเสร็จน้ำ
              data.transaction_payments = data.transaction_payments.sort(fieldSorter(["water_current_month"]));
              const getP = (type) => {
                return data.transaction_payments[0][`s_${type}`] ? data.transaction_payments[0][type] : 0
              }
              const getT = (item) => {
                let past_total = 0;
                array_cost.map(type => {past_total += total(item.filter(e=>e[`s_${type}`]),type === 'late_payment' ? 'total_cost_late' : type);})
                return parseFloat(past_total.toFixed(2));;
              }
              const water_list_price = getT(data.transaction_payments.filter((e,i) => i !== 0)); //ค่าใช้จ่าย เดือนก่อนหน้า
              const total_calc = water_list_price + getT(data.transaction_payments.filter((e,i) => i === 0)) + data.add_on_add_debt - data.add_on_reduce_debt; //รวมทั้งสิ้น
      
              console.log("water_list_price:",water_list_price)
              console.log("total_calc:",total_calc)
      
              const lastMonth = new Date(data.last_date);
              lastMonth.setMonth(lastMonth.getMonth() - 1);
      
              let data_print = {
                ...baseHeader,
                water_current_month: data.last_date,
                water_last_month: data.brefore_last_date !== data.last_date ? data.brefore_last_date : format_date(lastMonth, "yyyy-mm-dd", "en"),
                last_gauge_number: data.last_gauge_number,
                current_gauge_number: data.current_gauge_number,
                unit_used: data.unit_used,
                water_bill: getP("water_bill"),
                equipment_maintenance_fee: getP("equipment_maintenance_fee"),
                waste_cost: getP("waste_cost"),
                common_expenses: getP("common_expenses"),
                water_list: data.transaction_payments || [],
                water_list_price,
                meter_connect_cost: getP("meter_connect_cost"),
                total_cost_late: getP("late_payment"),
                fire_cost: getP("fire_cost"),
                cable_cost: getP("cable_cost"),
                other_income: getP("other_income"),
                add_debt: getP("add_debt"),
                add_on_add_debt: data.add_on_add_debt,
                reduce_debt: getP("reduce_debt"),
                add_on_reduce_debt: data.add_on_reduce_debt,
                total: total_calc,
                change_satang: data.change_satang,
              };
      
              console.log("data_print:", data_print);
      
              localStorage.setItem("DATA_", JSON.stringify(data_print));
              window.open("/doc/receipt", "_blank");
            }
          } else {
            alert("warning", "แจ้งเตือน", "ไม่มีใบแจ้งหนี้");
            this.clear_form();
          }
        }catch(e){
          console.log(e);
          alert("warning", "แจ้งเตือน", "ไม่มีใบแจ้งหนี้");
        }
        loading(false);
  };

  clear_form = () => this.setState(this.getInitialState());

  handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    const resizedPhotos = [];
    files.forEach((file) => {
      Resizer.imageFileResizer(file, 720, 720, "JPG", 100, 0, (uri) => {
        resizedPhotos.push(uri.split(",")[1]);
        if (resizedPhotos.length === files.length) this.setState({ photo: resizedPhotos });
      }, "base64");
    });
  };

  render() {
    const { iw_number, data_customer, address_number, record_date, record_time, payment_type, transfer_date, transfer_time, full_name, project_name, address, data_manage, title, description, cost, total_amount } = this.state;

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="ข้อมูลจัดเก็บค่าใช้จ่าย" page3="บันทึกรายรับอื่นๆ" />

        <div className="body">
          <div className="p-3">
            <div className="d-flex row mx-0 align-items-center justify-content-between">
              <h4 className="mb-3"><b>บันทึกรายรับอื่นๆ เลขที่ใบแจ้งหนี้ : {iw_number || "-"}</b></h4>
            </div>

            <div className="card border-0 px-3 pt-3 mb-3">
              <div className="row">
                <div className="col-12 col-lg-4 col-xl-3">
                  <label>บ้านเลขที่</label>
                  <Select
                    className="form-control bg-contain border-0 select-search w-100 mb-3" styles={select_style} options={data_customer || []} value={address_number}
                    onChange={(e) => this.setState({ customer_id: e.customer_id, full_name: e.full_name, project_name: e.project_name, address: e.address || e.address_number, address_number: e })}
                  />
                </div>
                <div className="col-6 col-lg-4 col-xl-3 mb-3"><label>วันที่</label><DatePicker className="form-control bg-contain border-0" value={record_date} disabled /></div>
                <div className="col-6 col-lg-4 col-xl-3 mb-3"><label>เวลา</label><input type="time" className="form-control w-100 bg-contain border-0" value={record_time} disabled /></div>

                <div className="col-12 col-lg-4 col-xl-3 mb-2">
                  <label>เลือกวิธีการชำระ</label>
                  <div className="d-flex" style={{ height: 60 }}>
                    <div className="d-flex wpx-100 align-items-center"><input type="radio" checked={payment_type === 1} onChange={(e) => e.target.checked && this.setState({ payment_type: 1, transfer_date: "", transfer_time: "" })} /><label className="mb-0 ml-3">เงินสด</label></div>
                    <div className="d-flex wpx-100 align-items-center"><input type="radio" checked={payment_type === 2} onChange={(e) => e.target.checked && this.setState({ payment_type: 2, transfer_date: "", transfer_time: "" })} /><label className="mb-0 ml-3">เงินโอน</label></div>
                  </div>
                </div>

                {payment_type === 2 && (
                  <>
                    <div className="col-6 col-lg-4 col-xl-4 mb-3"><label>วันที่โอน</label><DatePicker className="form-control bg-contain border-0" onChange={(e) => this.setState({ transfer_date: e })} value={transfer_date} /></div>
                    <div className="col-6 col-lg-4 col-xl-4 mb-3"><label>เวลาโอน</label><input type="time" className="form-control w-100 bg-contain border-0" onChange={(e) => this.setState({ transfer_time: e.target.value })} value={transfer_time} /></div>
                    <div className="col-6 col-lg-4 col-xl-4 mb-3"><label>รูปสลิปโอนเงิน</label><input type="file" accept="image/*" className="d-block w-100 border-0 pt-2 pb-0 px-2" style={{ appearance: "none", background: "none" }} multiple onChange={this.handleImageUpload} /></div>
                  </>
                )}

                <div className="col-12 col-md-4 mb-3"><label>ชื่อ-นามสกุล</label><input type="text" className="form-control w-100 bg-contain border-0" onChange={(e) => this.setState({ full_name: e.target.value, customer_id: "", address_number: null })} value={full_name} maxLength={100} /></div>
                <div className="col-12 col-md-4 mb-3"><label>ชื่อหน่วยงาน</label><input type="text" className="form-control w-100 bg-contain border-0" onChange={(e) => this.setState({ project_name: e.target.value, customer_id: "", address_number: null })} value={project_name} maxLength={200} /></div>
                <div className="col-12 col-md-4 mb-3"><label>ที่อยู่</label><input type="text" className="form-control w-100 bg-contain border-0" onChange={(e) => this.setState({ address: e.target.value, customer_id: "", address_number: null })} value={address} maxLength={500} /></div>
              </div>
            </div>

            <div className="card border-0 p-3 mb-3">
              <table className="table table-borderless table-striped">
                <thead>
                  <tr className="bg-dark-blue text-white">
                    <th className="text-center wpx-120">ลำดับที่</th><th className="text-center">รายการ</th><th className="text-center">รายละเอียด</th><th className="text-right wpx-200">ราคารวมสุทธิ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-center">
                      <Select
                        className="form-control border-0 select-search w-100 mb-3" styles={select_style}
                        options={data_manage ? data_manage.map(data => ({ value: data.title, label: data.code })) : []}
                        onChange={(e) => this.setState({ code: e.label, title: e.value })}
                      />
                    </td>
                    <td><input type="text" className="form-control" value={title} readOnly /></td>
                    <td><textarea className="form-control" placeholder="รายละเอียด" onChange={(e) => this.setState({ description: e.target.value })} value={description} maxLength={2000} /></td>
                    <td><input type="text" className="form-control" onChange={(e) => float(e.target.value) && this.setState({ cost: e.target.value, total_amount: Number(e.target.value) })} value={cost} maxLength={11} /></td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="card border-0 p-3 mb-3">
              <div className="w-100 d-flex justify-content-between"><b>จัดเก็บเงินทั้งสิ้น</b> <b>฿{toFixed(total_amount)}</b></div>
            </div>

            {create_r && (
              <button
                className="btn btn-outline-primary bg-white w-100 mb-4"
                disabled={this.state.disable_button}
                onClick={() => {
                  let valid = payment_type === 1 ? ["code", "title", "cost"] : ["transfer_date", "transfer_time", "code", "title", "cost"];
                  if (payment_type === 2 && this.state.is_upload_slip && !this.state.photo.length) return alert("warning", "แจ้งเตือน", "กรุณาอัพโหลดสลิปการโอนเงิน");
                  if (!validate(this.state, valid)) this.Create();
                }}
              >พิมพ์ใบเสร็จ</button>
            )}
          </div>
        </div>
      </div>
    );
  }
}